import { render } from "./SelectColony.vue?vue&type=template&id=56519616&ts=true"
import script from "./SelectColony.vue?vue&type=script&lang=ts"
export * from "./SelectColony.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__